/**
 * Created by tdunham on 6/27/2017.
 */

import {Injectable}                                 from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, Router}    from '@angular/router';

import {News}                                       from "./news";
import {NewsService}                                from './news-service';

import {Observable}                                 from "rxjs";


@Injectable()
export class NewsResolve implements Resolve<News> {

	constructor(

		private newsService: NewsService,
		private router: Router

	) {}


	/**
	 * Retrieve the article in advance of its use.
	 *
	 * @param route    Used to get the article ID from the parameter passed via the URL.
	 * @returns {any}  The located item or an empty News object.
	 */
	resolve(route: ActivatedRouteSnapshot): Observable<News> {

		// Handle 'new' or non-integer value as the ID.
		if ('new' === route.params['id']) {

			return Observable.of(new News());

		}

		// Handle any integer ID.
		return this.newsService.getNewsItem(route.params['id']);

	}

}


// WEBPACK FOOTER //
// ./src/app/services/news/news.resolve.ts